import {InteractiveQuery, _InteractiveQuery} from './interactive-query';

/**
 * Generated from com.dataiku.dip.eda.worksheets.queries.ListMostFrequentValues
 */
export interface ListMostFrequentValues extends _InteractiveQuery {
    column: string;
    maxValues: number;

    // PolyJson type
    type: 'list_most_frequent_values';
}

export function isListMostFrequentValues(toTest: InteractiveQuery): toTest is ListMostFrequentValues { return 'list_most_frequent_values' === toTest.type; }

export namespace ListMostFrequentValues {
    /**
     * Generated from com.dataiku.dip.eda.worksheets.queries.ListMostFrequentValues$ListMostFrequentValuesResult
     */
    export interface ListMostFrequentValuesResult extends InteractiveQuery._InteractiveQueryResult {
        values: string[];

        // PolyJson type
        type: 'list_most_frequent_values';
    }

    export function isListMostFrequentValuesResult(toTest: InteractiveQuery.InteractiveQueryResult): toTest is ListMostFrequentValuesResult { return 'list_most_frequent_values' === toTest.type; }
}